import type { WasteHotspot } from '../../types';
import { PointEntityDetailsPanel } from '../../../../spatial/components/PointEntityDetailsPanel';

export interface HotspotDetailsPanelProps {
  hotspot: WasteHotspot;
  onClose: () => void;
}

function formatReportedAt(value: string): string {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString('es-AR');
}

export function HotspotDetailsPanel({
  hotspot,
  onClose,
}: HotspotDetailsPanelProps): JSX.Element {
  return (
    <PointEntityDetailsPanel
      title="Microbasural"
      code={hotspot.code}
      subtitle={hotspot.name || 'Sin referencia'}
      projectId={hotspot.project.id}
      entityType="waste_hotspot"
      entityId={hotspot.id}
      coordinates={hotspot.geometry.coordinates as [number, number]}
      onClose={onClose}
      fields={[
        { label: 'Intensidad', value: `${hotspot.intensity}/5` },
        { label: 'Frecuencia', value: hotspot.frequency },
        { label: 'Estado', value: hotspot.status },
        { label: 'Lado', value: hotspot.streetSide || 'Sin definir' },
        { label: 'Volumen', value: hotspot.estimatedVolume || 'Sin definir' },
        { label: 'Residuos', value: hotspot.wasteTypes.join(', ') || 'Sin definir' },
        { label: 'Causa probable', value: hotspot.probableCause || 'Sin definir' },
        { label: 'Reportado', value: formatReportedAt(hotspot.reportedAt) },
      ]}
    />
  );
}
